import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {MessageDeletionType} from '@toolify/server/src/models/mongoose/MessageModel/enum/MessageDeletionType'
import {isThreadConversationType} from '@toolify/server/src/services/MessageService/functions/isThreadConversationType'

export function getDeletedMessageLabelKey(message: {
  conversationType: ConversationType
  deletionType?: MessageDeletionType | null
}): string | null {
  if(!message.deletionType) {
    return null
  }
  const isComment = isThreadConversationType(message.conversationType)
  if(message.deletionType === MessageDeletionType.Admin) {
    return isComment ? 'chat.deletedCommentByAdmin' : 'chat.deletedMessageByAdmin'
  }
  return isComment ? 'chat.deletedComment' : 'chat.deletedMessage'
}
